module.exports = __webpack_public_path__ + "img/martina-antuofermo.56eeb38e.png";